/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SmartForm } from 'components';
import { saveSetting, getSetting } from 'rdx/config';
import { valueToInteger } from 'utils';

import saleDocumentsSchema from './saleDocumentsSchema';
import './saleDocuments.scss';

function SaleDocuments() {
  const settingsFormRef = React.useRef(null);
  const dispatch = useDispatch();
  const [configState, setConfigState] = useState({});

  const touchpos_always_item_in_new_row = useSelector(
    getSetting('touchpos_always_item_in_new_row'),
  );
  const show_original_price_on_receipt = useSelector(
    getSetting('show_original_price_on_receipt'),
  );
  const touchpos_enable_default_send_receipt_to_email = useSelector(
    getSetting('touchpos_enable_default_send_receipt_to_email'),
  );
  const touchpos_autoclose_checkout_final_confirmaton_popup = useSelector(
    getSetting('touchpos_autoclose_checkout_final_confirmaton_popup'),
  );
  const sale_extra_note1 = useSelector(getSetting('sale_extra_note1'));
  const sale_extra_note3 = useSelector(getSetting('sale_extra_note3'));
  const sale_extra_note2 = useSelector(getSetting('sale_extra_note2'));

  useEffect(() => {
    setConfigState({
      touchpos_always_item_in_new_row,
      show_original_price_on_receipt,
      touchpos_enable_default_send_receipt_to_email,
      touchpos_autoclose_checkout_final_confirmaton_popup,
      sale_extra_note1,
      sale_extra_note3,
      sale_extra_note2,
    });
  }, [
    touchpos_always_item_in_new_row,
    show_original_price_on_receipt,
    touchpos_enable_default_send_receipt_to_email,
    touchpos_autoclose_checkout_final_confirmaton_popup,
    sale_extra_note1,
    sale_extra_note3,
    sale_extra_note2,
  ]);

  const submitSetting = () => {
    const { values: currentValues } = settingsFormRef.current;

    Object.entries(currentValues).forEach(([key, value]) => {
      const payload = {};

      payload.parameterName = key;
      payload.parameterValue =
        typeof value === 'boolean' ? valueToInteger(value) : value;

      if (payload.parameterValue !== configState[key])
        dispatch(saveSetting(payload));
    });
  };
  return (
    <SmartForm
      grid
      ref={settingsFormRef}
      state={configState}
      fields={saleDocumentsSchema}
      autosave
      handleSubmit={submitSetting}
      className="sale-documents-form"
    />
  );
}

export default SaleDocuments;
